module.exports = __webpack_public_path__ + "static/media/logo.1cc3bc5e.png";